import { useShowFeature } from '@seek/ca-myprofile-utils';
import { useMelwaysInfo } from '@seek/melways-react';

import { useAppConfig } from '../appConfig';

import { isFeatureActive } from '.';

export const usePeopleSearchEnabled = () => {
  const { language: melwaysLanguage } = useMelwaysInfo();
  const { zone } = useAppConfig();
  const showFeature = useShowFeature(zone, melwaysLanguage);

  return isFeatureActive('people-search') || showFeature('people-search');
};
